import React from "react";

import useTranslations from "../../hooks/useTranslations";

import { H3 } from "../wombat-ui";

const ReportEmptyState: React.FC = () => {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-center justify-center -mb-6">
      <div className="max-w-md text-center">
        <H3>{t("reports.toBeFilled")}</H3>
        <p className="mt-2 text-sm text-dark-100 whitespace-nowrap">
          {t("reports.startByAddingQuestion")}
        </p>
      </div>
    </div>
  );
};

export default React.memo(ReportEmptyState);
